var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLingualBuccal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5904 8.48279C19.432 8.70901 19.487 9.02078 19.7133 9.17914C19.9395 9.3375 20.2512 9.28249 20.4096 9.05627L19.5904 8.48279ZM24.5 2.34131L19.2677 4.78189L23.9975 8.0929L24.5 2.34131ZM20.4096 9.05627L22.3289 6.31453L21.5097 5.74104L19.5904 8.48279L20.4096 9.05627Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6543 25.81C17.7819 25.8309 17.9043 25.8413 18.0266 25.8413C18.9681 25.8413 19.766 25.1833 19.9894 24.2797C20.7766 21.073 23 13.4062 23 11.4216C23 8.89381 20.9096 6.84131 18.3351 6.84131C17.6809 6.84131 17.0585 6.97187 16.4947 7.21212C16.0213 7.41058 15.5106 7.51503 15 7.51503C14.4894 7.51503 13.9787 7.4158 13.5053 7.21212C12.9415 6.97187 12.3191 6.84131 11.6649 6.84131C9.09043 6.84131 7 8.89381 7 11.4216C7 13.1607 9.20213 21.073 9.9734 24.2797C10.1915 25.1833 10.9894 25.8413 11.9362 25.8413C12.0585 25.8413 12.1862 25.8309 12.3138 25.8048C13.2713 25.6272 13.9362 24.7654 13.9362 23.8097V21.6319C13.9362 20.8015 14.4043 20.3419 14.984 20.3419C15.5638 20.3419 16.0319 20.8015 16.0319 21.3707V23.8097C16.0319 24.7654 16.6968 25.6324 17.6596 25.81H17.6543Z",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.933 17.0913C15.0711 16.8522 14.9891 16.5464 14.75 16.4083C14.5109 16.2702 14.2051 16.3522 14.067 16.5913L14.933 17.0913ZM7 29.8317L12 26.9449L7 24.0582L7 29.8317ZM14.067 16.5913L8.81699 25.6846L9.68301 26.1846L14.933 17.0913L14.067 16.5913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLingualBuccal);
export default __webpack_public_path__ + "static/media/Icon_Lingual_Buccal.f5f2c0cb718d6d19af543bb8e0091002.svg";
export { ForwardRef as ReactComponent };